import { combineReducers } from 'redux'
import loadingReducer from './loading.reducer'
import notifyReducer from './notify.reducer'
import alertReducer from './alert.reducer'
import authReducer from './auth.reducer'
import usuariosReducer from './usuarios.reducer'
import actionsReducer from './actions.reducer'
import cotasReducer from './cotas.reducer'
import linksReducer from './links.reducer'
import navigationReducer from './navigation.reducer'
import appReducer from './app.reducer'
import accountReducer from './account.reducer'
import metricsReducer from './metrics.reducer'
import transactionReducer from './transaction.reducer'
import shoppingReducer from './shopping.reducer'
import smsReducer from './sms.reducer'

const rootReducer = combineReducers({
    loadingReducer,
    notifyReducer,
    alertReducer,
    authReducer,
    usuariosReducer,
    actionsReducer,
    cotasReducer,
    metricsReducer,
    navigationReducer,
    appReducer,
    accountReducer,
    transactionReducer,
    linksReducer,
    shoppingReducer,
    smsReducer
})

export default rootReducer;